import clsx from "clsx";
import { FC } from "react";

import { useNameFromPageAccessId } from "../../page/helpers";

import { ACCESS_ID_QUERY_PARAM } from "components/constants";
import { t } from "i18n/i18n";
import { LegacyButton } from "mds/components/LegacyButton";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { pageSelectors, selectCurrentUserId, selectIsPracticeClassSession } from "store/selectors";
import { presentSession, setPresentationWindow, usePresentation } from "utils/presentation";
import { useParams, useQueryParamsManager } from "utils/routing";

interface FeatureResponsesButtonProps {
  className?: string;
}

export const FeatureResponsesButton: FC<FeatureResponsesButtonProps> = ({ className }) => {
  const pathParams = useParams();
  const selectedPageId = pathParams.pageId;
  const userId = useAppSelector(selectCurrentUserId);
  const { canAuthorSection } = useCapabilities();
  const selectedPage = useAppSelector((s) => pageSelectors.selectById(s, selectedPageId));
  const { presentedPageId, unfeaturedTab, isPresenting, presentedSessionId } = usePresentation();
  const isPracticeClassSession = useAppSelector(selectIsPracticeClassSession);
  const { getQueryParam } = useQueryParamsManager();
  const selectedAccessId = getQueryParam(ACCESS_ID_QUERY_PARAM);
  const participantName = useNameFromPageAccessId(selectedAccessId, presentedPageId);

  if (
    !presentedSessionId ||
    !selectedPage ||
    !unfeaturedTab ||
    !presentedPageId ||
    !canAuthorSection ||
    !isPresenting
  ) {
    return null;
  }

  const onFeatureResponses = () => {
    setPresentationWindow();
    presentSession(presentedSessionId, {
      page: selectedPage,
      accessId: selectedAccessId,
      isRollup: true,
      isPractice: isPracticeClassSession,
      userId,
    });
  };

  return (
    <LegacyButton
      className={clsx(
        "!border-green !bg-white !px-3 !py-1 !text-sm !font-medium !text-green",
        className,
      )}
      eventName="Feature class responses"
      kind="secondary"
      size="xs"
      onClick={onFeatureResponses}
    >
      {participantName
        ? t("main_header.feature_status.feature_button_text", { name: participantName })
        : t("main_header.feature_status.feature_all_button_text")}
    </LegacyButton>
  );
};
